import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-errores',
  templateUrl: './modal-errores.component.html',
  styleUrls: ['./modal-errores.component.scss']
})
export class ModalErroresComponent implements OnInit {

  displayedColumns: string[] = ['tipoError', 'totalErrores', 'acciones'];
  columnasListaEspecifica: string[] = ['fila', 'columna', 'dato'];
  numeroErrores: number;
  datosErrores: any[] = [];
  pasoErrores: number;
  listaEspecifica: any[] = [];
  listaExcedente: boolean;
  totalExcedentes: number;
  headerSecEsp: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalErroresComponent>,
    private translateSrv: TranslateService,
  ) { }

  ngOnInit(): void {
    this.numeroErrores = this.datos.erroresTotales;
    for(let tipo in this.datos.erroresCategorizados){
      this.datosErrores.push({
        tipo,
        total: this.datos.erroresCategorizados[tipo].length,
        lista: this.datos.erroresCategorizados[tipo]
      });
    }
  }

  infoError(detalleError:string){
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    Swal.fire({
      title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.CARD_ERRLIST.DESCRIPCION.'+detalleError),
      icon: 'warning',
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  verListaErrores(lista:any){
    this.listaEspecifica = [];
    let maximoLista = lista.length <= 20 ? lista.length : 20;
    this.listaExcedente = lista.length <= 20 ? false : true;
    this.totalExcedentes = lista.length <= 20 ? 0 : lista.length - 20;
    for (let i = 0; i < maximoLista; i++) {
      this.listaEspecifica.push({
        fila: lista[i].numeroFila,
        columna: lista[i].numeroColumna,
        dato: lista[i].dato,
        tipoError: lista[i].tipoError
      });
    }
    this.headerSecEsp = lista[0].tipoError == 'seccionSinUsar' ? true : false;
    this.pasoErrores = 1;
  }

  salir(){
    this.dialogRef.close();
  }

}
